import React from "react";
import Logos from "./Logos";

import MenuIcon from "@material-ui/icons/Menu";

import { Box, IconButton } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const StyledIconButton = withStyles((theme) => {
  return {
    root: {
      padding: theme.spacing(1),
      [theme.breakpoints.up("sm")]: {
        // fontSize: "2.2rem",
      },
    },
  };
})(IconButton);

export default function AppHeader({ onOpenDrawer, children }) {
  return (
    <Box pl={1} pr={1} display="flex" direction="row" alignItems="center">
      <StyledIconButton
        color="inherit"
        aria-label="open drawer"
        onClick={onOpenDrawer}
      >
        <MenuIcon />
      </StyledIconButton>

      <Box flexGrow={1}>{children}</Box>
      <Logos />
    </Box>
  );
}
